<template>
	<svg id="shape" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 574.69 741.47" :width="width" :height="height">
		<g>
			<polygon points="248.46 622.82 129.83 504.18 248.44 385.57 248.44 385.55 248.47 385.57 248.47 266.93 218.81 237.27 337.43 118.65 337.43 0 100.16 237.27 189.15 326.25 11.2 504.2 248.46 741.47 485.73 504.2 367.17 504.2 248.46 622.82" style="fill: #ffffff" />
			<polygon points="337.43 474.53 574.69 237.27 456.06 118.63 367.08 207.61 426.4 207.63 456.05 237.28 337.43 355.9 337.43 474.53" style="fill: #ffffff" />
		</g>
		<polygon points="322.63 459.73 322.63 341.1 263.28 281.75 263.28 400.39 322.63 459.73" style="fill: #fcc80c" />
	</svg>
</template>

<script>
export default {
	name: 'Logo',
	props: {
		width: {
			type: String,
			default: '574',
		},
		height: {
			type: String,
			default: '741',
		},
	},
}
</script>

<style scoped></style>
